/**
 * 一行代码生成UUID（小写字母+数字）
 * @returns {string} UUID
 */
export function generateUUID(length = 8) {
    return Math.random().toString(36).slice(-length).padStart(length, '0');
}
